// 历史记录管理模块
// 用于管理全局的撤销/恢复操作

const state = {
  // 历史记录数组，存储每个操作的状态
  history: [],
  // 当前历史记录索引
  historyIndex: -1,
  // 最大历史记录数量
  maxHistoryLength: 30,
  // 初始状态
  initMelodyState: null,
};

const mutations = {
  // 设置初始状态
  SET_INIT_STATE(state, initState) {
    state.initMelodyState = initState;
  },

  // 保存历史记录
  SAVE_HISTORY(state, melodyData) {
    // 深拷贝当前 melodyData
    const melodyClone = JSON.parse(JSON.stringify(melodyData || []));
    const jsonString = JSON.stringify(melodyClone);

    // 检查是否与当前历史记录相同
    if (
      state.history.length > 0 &&
      state.historyIndex >= 0 &&
      state.history[state.historyIndex] === jsonString
    ) {
      console.log("与当前全局历史记录相同，不重复保存");
      return;
    }

    // 如果当前不在历史记录的最后一项，删除后面的记录
    if (state.historyIndex < state.history.length - 1) {
      state.history = state.history.slice(0, state.historyIndex + 1);
    }

    state.history.push(jsonString);
    state.historyIndex = state.history.length - 1;

    // 限制历史记录长度
    if (state.history.length > state.maxHistoryLength) {
      state.history.shift();
      state.historyIndex = state.history.length - 1;
    }

    console.log(
      "保存全局历史记录索引:",
      state.historyIndex,
      "全局历史记录:",
      state.history
    );
  },

  // 撤销操作
  UNDO(state) {
    if (state.historyIndex >= 0 && state.history.length > 0) {
      state.historyIndex--;
      //   console.log("撤销成功", state.historyIndex, state.history);
    }
  },

  // 恢复操作
  REDO(state) {
    if (state.historyIndex < state.history.length - 1) {
      state.historyIndex++;
      //   console.log("恢复成功", state.historyIndex, state.history);
    }
  },

  // 重置历史记录
  RESET_HISTORY(state) {
    state.history = [];
    state.historyIndex = -1;
    state.initMelodyState = null;
  },
};

const actions = {
  // 设置初始状态
  setInitState({ commit }, initState) {
    commit("SET_INIT_STATE", initState);
  },

  // 保存历史记录
  saveHistory({ commit }, melodyData) {
    commit("SAVE_HISTORY", melodyData);
  },

  // 撤销操作
  undo({ commit, state }) {
    commit("UNDO");
    // 返回撤销后的状态
    let historyItem;
    if (state.historyIndex < 0) {
      historyItem = state.initMelodyState || JSON.stringify([]);
    } else {
      historyItem = state.history[state.historyIndex];
    }
    return historyItem ? JSON.parse(historyItem) : [];
  },

  // 恢复操作
  redo({ commit, state }) {
    commit("REDO");
    // 返回恢复后的状态
    const historyItem = state.history[state.historyIndex];
    return historyItem ? JSON.parse(historyItem) : [];
  },

  // 重置历史记录
  resetHistory({ commit }) {
    commit("RESET_HISTORY");
  },
};

const getters = {
  // 获取当前历史记录状态
  currentHistoryState: (state) => {
    if (state.historyIndex < 0) {
      return state.initMelodyState ? JSON.parse(state.initMelodyState) : [];
    }
    return state.history[state.historyIndex]
      ? JSON.parse(state.history[state.historyIndex])
      : [];
  },

  // 获取历史记录长度
  historyLength: (state) => state.history.length,

  // 获取当前历史记录索引
  currentHistoryIndex: (state) => state.historyIndex,

  // 是否可以撤销
  canUndo: (state) => state.historyIndex >= 0 && state.history.length > 0,

  // 是否可以恢复
  canRedo: (state) => state.historyIndex < state.history.length - 1,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
